export default __webpack_public_path__ + "static/media/enterprise.81024466.svg";